class BrochureCookiePicker extends BaseClass {
    constructor(el) {
        super(el);
        this.component = document;

        this.selectBar = this.component.querySelector(`[data-select]`);
        this.countText = this.selectBar.querySelector(`[data-count]`);

        this.brochures = this.component.querySelectorAll(`[data-brochure-cookie]`);

        this.selectedIds = [];
        
        this.cookieValue = "";

        this.init();

        this.bindEvents();
    }

    init() {

        let cookieValue;

        if (document.cookie !== undefined && document.cookie.includes('brochuresToDownload=') === true) {
            cookieValue = document.cookie
                .split('; ')
                .find(row => row.startsWith('brochuresToDownload='))
                .split('=')[1];
        }

        this.brochures.forEach(el => {

            el.button = el.querySelector(`[data-add-cookie]`);

            const brochureId = el.dataset.brochureId;
            el.brochureId = brochureId;

            if (`,${cookieValue},`.includes(`,${brochureId},`)) {
                el.classList.add('selected');
                this.selectedIds.push(brochureId);
            }
        });
        let cookieCount = 0;
        cookieCount = cookieValue ? parseInt(cookieValue?.split(',').length) : 0;
        this.cookieValue = cookieCount;
        
        this.updateButton();
        

    }

    bindEvents() {
        this.brochures.forEach(el => {
            el.addEventListener(
                'click',
                () => {
                    toggleClass(el, 'selected');
                    this.toggleId(el.brochureId);
                    this.brochures.forEach(brochure => {
                       const brochureId = brochure.dataset.brochureId;
                       if (el.brochureId === brochureId && brochure !== el){
                           toggleClass(brochure, 'selected');
                       }
                    });
                }
            )
        })
    }

    updateButton() {

        const brochureCount = this.cookieValue
        this.countText.textContent = `${brochureCount} Brochure${(brochureCount !== 1) ? 's' : ''} Selected`;

        if (brochureCount > 0) {
            this.selectBar.classList.add('open');
        } else {
            this.selectBar.classList.remove('open');
        }

    }

    toggleId(id) {
        const isAddedId = this.selectedIds.includes(id);

        if (isAddedId) {
            this.selectedIds = this.selectedIds.filter(el => el !== id);
            this.removeCookieValue(id);
            this.cookieValue--;
        } else {
            this.selectedIds.push(id);
            this.addCookieValue(id);
            this.cookieValue++;
        }

        this.updateButton();

        this.raiseEvent("listUpdated", this.selectedIds);

    }

    addCookieValue(id) {
        fetch(`/umbraco/surface/BrochuresCookie/AddBrochureId?brochureId=${id}`);
    }

    removeCookieValue(id) {
        fetch(`/umbraco/surface/BrochuresCookie/RemoveBrochureId?brochureId=${id}`);
    }

}

document.addEventListener('DOMContentLoaded', () => {
    let brochurePicker = new BrochureCookiePicker(document);    
});